import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { SignIn } from './SignIn';
import { Redirector } from './Redirector';
import { PasskeyManagement } from './PasskeyManagement';
import { ToastContainer } from 'react-toastify';
import { Col, Container, Row } from 'react-bootstrap';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Redirector />,
    children: []
  },
  {
    path: "/sign-in",
    element: <SignIn />
  },
  {
    path: "/passkeys",
    element: <PasskeyManagement />
  },
  {
    path: "/error",
    element: <div>Error</div>
  }
])

root.render(
  <React.StrictMode>
    <ToastContainer theme="dark" />
    <Container>
      <Row className="d-flex justify-content-center mt-3">
        <Col xs={3}>
          <RouterProvider router={router} />
        </Col>
      </Row>
    </Container>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
